import * as React from 'react';

import { RoomInfo } from './RoomInfo';
import * as styles from './newbuildingStats.css';
import { IRoomInfo } from '../../types/newobject/newbuildingRoomInfo';

interface INewbuildingStats {
  subtitle: string;
  newbuildingFeatures: React.ReactElement | null;
  roomsInfo: IRoomInfo[];
}

export const NewbuildingStats = ({ newbuildingFeatures, subtitle, roomsInfo }: INewbuildingStats) => {
  return (
    <section className={styles['container']}>
      {subtitle && (
        <div data-testid="newbuildingStatsSubtitle" className={styles['subtitle']}>
          {subtitle}
        </div>
      )}
      {newbuildingFeatures}
      <ul className={styles['rooms']}>
        {roomsInfo.map((item, index) => (
          <RoomInfo key={index} info={item} />
        ))}
      </ul>
    </section>
  );
};
